export default __webpack_public_path__ + "static/media/RadioButton.42367d78.svg";